import { Project } from '@/dashboard/types/project';
import { UserRole } from '@/dashboard/types/user_role';

export function getProjectCreator(project: Project) {
  const projectCreator = project.users?.find((user) => user.project_creator);
  const owner = project.users?.find((user) => user.role === UserRole.Owner);
  return projectCreator ?? owner;
}
